import DynastyTradingPage from "../pages/DynastyTradingPage";

const LEAGUE_OF_LEGENDS_SLEEPER_LEAGUE_ID = "1354658013155196928";

export default function LeagueOfLegendsPage() {
  return (
    <DynastyTradingPage
      fixedLeagueIdentifier={LEAGUE_OF_LEGENDS_SLEEPER_LEAGUE_ID}
      fixedLeagueLoadingImageSrc="/league-of-legends-loading.png"
      hideFindTrade
      hideLeagueSummary
      hideTopBanner
      hideTradeCalculations
      loadingTitle="League of Legends"
      loadingSubtitle="Refreshing this league from Sleeper."
      persistLeagueIdentifier={false}
      showOpenInKtc
      theme="leagueOfLegends"
    />
  );
}
